export default __webpack_public_path__ + "static/media/bankkart_logo.1d74df17.png";